import {
    FETCH_DRIVER_PARTNERS_REQUEST,
    FETCH_DRIVER_PARTNERS_SUCCESS,
    FETCH_DRIVER_PARTNERS_FAILURE,
    UPDATE_DRIVER_PARTNER_STATUS_REQUEST,
    UPDATE_DRIVER_PARTNER_STATUS_SUCCESS,
    UPDATE_DRIVER_PARTNER_STATUS_FAILURE,
} from "../actions/types";

const initialState = {
    driverPartners: [],

    loading: false,
    error: null,
    message: "",

    page: 1,
    hasMore: true,
    total: 0,

    size: 20,
    pages: 0,
};

export default function driverPartnerReducer(
    state = initialState,
    action
) {
    switch (action.type) {

   

        case FETCH_DRIVER_PARTNERS_REQUEST:
        case UPDATE_DRIVER_PARTNER_STATUS_REQUEST:

            return {
                ...state,
                loading: true,
                error: null,
            };


  

        case FETCH_DRIVER_PARTNERS_SUCCESS: {

            const {
                data,
                total,
                page,
                size,
                pages,
            } = action.payload || {};

            return {
                ...state,

                loading: false,

                driverPartners:
                    data || [],

                total:
                    total || 0,

                page:
                    page || 1,

                size:
                    size || 20,

                pages:
                    pages || 0,

                hasMore:
                    (page || 1) <
                    (pages || 0),

                message:
                    "Driver Partners loaded successfully",
            };
        }




        case FETCH_DRIVER_PARTNERS_FAILURE:
        case UPDATE_DRIVER_PARTNER_STATUS_FAILURE:

            return {
                ...state,

                loading: false,

                error:
                    action.payload,
            };




        case UPDATE_DRIVER_PARTNER_STATUS_SUCCESS:

            return {
                ...state,

                loading: false,

                driverPartners:
                    Array.isArray(
                        state.driverPartners
                    )
                        ? state.driverPartners.map(
                              (
                                  partner
                              ) =>
                                  partner
                                      ?.driver_partner
                                      ?.driver_partner_id ===
                                  action.payload
                                      ?.driver_partner_id
                                      ? {
                                            ...partner,

                                            driver_partner:
                                                {
                                                    ...partner.driver_partner,

                                                    ...action.payload,
                                                },
                                        }
                                      : partner
                          )
                        : [],

                message:
                    "Driver Partner status updated successfully",
            };


        default:
            return state;
    }
}